import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useHomeDispatch } from "./home-context";

export const useHomeController = () => {
    const homeDispatch = useHomeDispatch();
    /** newsLimit: quantidade de notícias buscadas (a home customizada pode exibir até 20). */
    async function getData(newsLimit: number = 4) {
        try {
            const banners = await PortalAppService.listBanners();
            homeDispatch({
                type: ACTION_TYPES.setBanners,
                payload: banners,
            });

            const menus = await PortalAppService.listMenus();
            homeDispatch({
                type: ACTION_TYPES.setMenus,
                payload: menus,
            });

            const news = await PortalAppService.listNewsLimit(newsLimit);
            homeDispatch({
                type: ACTION_TYPES.setTopNews,
                payload: news?.items || [],
            });

            var groupBidsModality = await PortalAppService.listGroupedBidsModality();
            homeDispatch({
                type: ACTION_TYPES.setGroupedBidsModality,
                payload: groupBidsModality,
            });

            var groupDailyOfficial = await PortalAppService.listGroupedDailyOfficial();
            homeDispatch({
                type: ACTION_TYPES.setGroupedDailyOfficial,
                payload: groupDailyOfficial,
            });

            var groupedPublicAccountSubcategory = await PortalAppService.listPublicAccountSubcategory();
            homeDispatch({
                type: ACTION_TYPES.setGroupedPublicAccountSubcategory,
                payload: groupedPublicAccountSubcategory,
            });

            var managementUnit = await PortalAppService.listManagementUnit();
            homeDispatch({
                type: ACTION_TYPES.setManagementUnit,
                payload: managementUnit,
            });

            var categoriesWithSubcategories = await PortalAppService.listCategoriesWithSubcategories();
            homeDispatch({
                type: ACTION_TYPES.setCategoriesWithSubcategories,
                payload: categoriesWithSubcategories,
            });

        } catch (error) {
            console.log(error);
        }
    }

    return {
        getData
    };
}